
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import { Money } from 'v-money';
import ProductService from "@/services/lead/ProductService";
import ActionService from "@/services/lead/ActionService";
import StatusService from "@/services/lead/StatusService";
import vSelect from "vue-select";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { mapGetters } from "vuex";

@Component({
  components: {
    LayoutDefault,
    Money,
    vSelect
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  }
})
export default class Product extends Vue {

  private productService = new ProductService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private productList: any;

  /**
   * @type Object
   * Status list returned from backend routes
   */
  private statusList: any = [];

  /**
   * @type Object
   * Actions list returned from backend
   */
  private actionList: any = [];

  /**
   * @type Object
   * insert/edit Product
   */
  private product: any = {
    id_product: null,
    price: 0,
    description: null,
    status: null,
    platformId: this.$auth.user().id_platform,
    attribute_data: {}
  };

  private productAttributes: [any?] = [];

  private moneyMask: any = {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: true /* doesn't work with directive */
  }

  /**
   * @type boolean
   * Help to control error message
   */
  private showDangerAlert: boolean = false;
  private dangerAlertMessage: string = "";

  /**
   * @type boolean
   * Help to control success message
   */
  private showSuccessAlert: boolean = false;
  private successAlertMessage: string = "";

  /**
   * @type object
   * Help control error form for send or not
   */
  private productFormError: object = {
    price: { state: null, message: "Campo Obrigatório" },
    description: { state: null, message: "Campo Obrigatório" },
    status: { state: null, message: "Campo Obrigatório" }
  };

  /**
   * @type
   * Help to control show loading icon
   */
  private loading: boolean = false;
  private editing: boolean = false;

  /**
   * @tyoe Array
   * Define columns from datatables
   */
  private columns = [
    { data: "id_product", name: "id_product", title: "ID", orderable: true },
    {
      data: "description",
      name: "description",
      title: "Descrição",
      orderable: true,
      defaultContent: "--",
      searchable: true
    },
    { data: "price", name: "price", title: "Valor", orderable: true },
    { data: "fk_id_action", name: "action", title: "Ação", orderable: true, defaultContent: "--" },
    { data: "fk_id_status", name: "status", title: "Situação", orderable: true }
  ];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  /**
   * Method created life cycle
   */
  private created() {
  }

  private get descriptionState() {
    if (this.product["description"] != null) {
      this.productFormError["description"].state =
        (this.product["description"] != null && this.product["description"] != "") ? true : false;
    }
    return this.productFormError["description"].state;
  }

  private get priceState() {
    if (this.product["price"] != null) {
      this.productFormError["price"].state =
        (this.product["price"] != null && this.product["price"] != "") ? true : false;
    }
    return this.productFormError["price"].state;
  }

  private get statusState() {
    if (this.product["status"] != null) {
      this.productFormError["status"].state =
        (this.product["status"] != null) ? true : false;
    }
    return this.productFormError["status"].state;
  }

  /**
   * Method for validation form add product
   */
  private validateForm() {
    let isFormValid = true;

    for (let elem in this.productFormError) {
      this.productFormError[elem].state =
        ((this.product[elem] != null && this.product[elem] !== "") ||
        (this.product.attribute_data[elem] != null && this.product.attribute_data[elem] !== "")) ? true : false;
      isFormValid = isFormValid && this.productFormError[elem].state;
    }
    return isFormValid;
  }

  /**
   * Custom state computed properties setted on the fly
   */
  private customFieldState = {};

  /**
   * Input handler of product fields
   */
  private validationOnChange(value, attribute) {
    if (this.productAttributes && attribute.required)
      this.productFormError[attribute.name].state = (value != null && value != '') ? true : false;
  }

  /**
   * Choose between add and update method
   */
  private formSubmit() {
    return this.editing ? this.updateProduct() : this.addProduct();
  }

  /**
   * Method for add new product
   */
  private addProduct() {

    if (!this.validateForm()) return;

    this.product.actionId = this.product.action && this.product.action.id_action ? this.product.action.id_action : null;
    this.product.statusId = this.product.status.id_status;
    this.product.price = this.product.price.replace(/((?![0-9,]).)*/g, '').replace(/,/, '.');
    for (let attr of this.productAttributes) {
      // Avoiding inserting blanks on DB
      if (!attr.required && (this.product.attribute_data[attr.name] === '' || this.product.attribute_data[attr.name] === null))
        delete this.product.attribute_data[attr.name];
    }

    this.loading = true;
    this.productService.store(this.product).then((res: any) => {
      if (JSON.stringify(res).toLowerCase().indexOf("success") !== -1) {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", "Produto adicionado com sucesso!");
        this.productList.ajax.reload();
      } else {
        this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao adicionar produto.");
      }
      this.loading = false;
      this.closeProductModal();
    });
  }

  /**
   * Method for update product
   */
  private updateProduct() {

    if (!this.validateForm()) return;

    this.loading = true;

    let requestBody: any = {
      description: this.product.description,
      price: this.product.price.replace(/((?![0-9,]).)*/g, '').replace(/,/, '.'),
      fk_id_status: this.product.status.id_status,
      fk_id_action: this.product.action ? this.product.action.id_action : null
    }

    if (this.productAttributes.length > 0) requestBody.attribute_data = {};
    for (let attr of this.productAttributes) {
      // Avoiding inserting blanks on DB
      if (attr.required || (this.product.attribute_data[attr.name] !== '' && this.product.attribute_data[attr.name] !== null)) {
        requestBody.attribute_data[attr.name] = this.product.attribute_data[attr.name];
      }
    }

    this.productService.update(this.product.id_product, requestBody).then((res: any) => {
      if (JSON.stringify(res).toLowerCase().indexOf("success") !== -1) {
        this.$store.commit("navBarAlert/SUCCESS_ALERT", 'Produto modificado com sucesso!');
        this.productList.ajax.reload();
      } else {
        this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao modificar produto.');
      }
      this.loading = false;
      this.closeProductModal();
    });
  }

  /**
   * Method close modal from add new product and reset product state
   */
  private closeProductModal() {
    this.hideModal("modal-add-product");
    this.product.description = null;
    this.product.price = 0;
    this.product.action = null;
    this.editing = false;

    this.productFormError["description"].state = null;
    this.productFormError["price"].state = null;

    for (let attr of this.productAttributes) {
      this.product.attribute_data[attr.name] = null;
      if (attr.required) this.productFormError[attr.name].state = null;
    }
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable(self) {

    if (self.allowedFeature('create-product'))
        this.buttons.push({ extend: "addProduct" });

    this.productList = this.$('#productList').DataTable({
      autoWidth: true,
      responsive: true,
      processing: true,
      searching: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + "lead/product/" + this.$auth.user().id_platform,
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },
      columnDefs: [
        {
          targets: 1
        },
        {
          className: "nowrap",
          render: (data, type, row) => {
            let split = data.toString().split('.');
            if (split.length == 1)
              return 'R$ ' + split[0] + ',00';
            else if (split.length > 1)
              return 'R$ ' + split[0] + ',' + split[1] + ((split[1].length == 1) ? '0' : '');
            else return data;
          },
          targets: 2
        },
        {
          className: "nowrap",
          render: (data, type, row) => {

            for (let action of this.actionList) {
              if (action.id_action === data)
                return action.label;
            }
          },
          targets: 3
        },
        {
          className: "nowrap",
          render: (data, type, row) => {

            for (let status of this.statusList) {
              if (status.id_status == data)
                return status.label;
            }
          },
          targets: 4
        },
        {
          className: "nowrap dt-right",
          render: (data, type, row) => {
            let buttons = "";
            if (self.allowedFeature('create-product')) {
              buttons +=
                "<button class='editButton' type='button' style='padding: 0; border: 0; background-color: transparent;'><i class='far fa-edit'></i></button>&nbsp;";
            }
            return buttons;
          },
          targets: this.columns.length - 1
        }
      ],
      columns: this.columns,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        sSearch: "Pesquisar",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.product.id_product = this.productList
            .row(this.$(e.target).parents("tr"))
            .data().id_product;
          this.product.description = this.productList
            .row(this.$(e.target).parents("tr"))
            .data().description;
          this.product.price = this.productList
            .row(this.$(e.target).parents("tr"))
            .data().price;
          for (let action of this.actionList) {
            if (action.id_action == this.productList
              .row(this.$(e.target).parents("tr"))
              .data().fk_id_action)
              this.product.action = action;
          }
          for (let status of this.statusList) {
            if (status.id_status == this.productList
              .row(this.$(e.target).parents("tr"))
              .data().fk_id_status)
              this.product.status = status;
          }
          for (let attr of this.productAttributes) {
            let attrDataDT = this.productList.row(this.$(e.target).parents("tr")).data().attribute_data;
            if (attrDataDT)
              this.product.attribute_data[attr.name] = attrDataDT[attr.name];
            else
              this.product.attribute_data[attr.name] = null;
          }
          this.editing = true;
          this.$bvModal.show("modal-add-product");
        });
      }
    });

    this.productList
      .buttons()
      .container()
      .appendTo("#dt-actions");
  }

  /**
   * Gets platform's product attributes to be used in add/edit product modal
   * @returns an array with platform's product attributes
   */
  private loadProductAttributes(): Promise<any> {

    return new Promise((resolve, reject) => {

      this.productService.attributeIndex().then((response: any) => {
        for (let attribute of response.body) {
          this.productAttributes.push(attribute);

          this.product.attribute_data[attribute.name] = null;

          if (attribute.required) {
            this.productFormError[attribute.name] = { state: null, message: "Campo Obrigatório" };
            let self = this;
            this.customFieldState[attribute.name] = {
              // On the fly computed property
              get getter() {
                return self.productFormError[attribute.name].state;
              }
            }
          }
        }
        resolve(response.body);
      },
      (error: any) => {
        reject(error);
      });
    });
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;

    this.loading = true;
    let promises: [Promise<any>?] = [];

    promises.push(new Promise(async (resolve, reject) => {
      self.loadProductAttributes().then((productAttributes) => {
        for (let attr of productAttributes)
          this.columns.push({ data: `attribute_data.${attr.name}`, name: `attribute_data.${attr.name}`, title: attr.label, orderable: false, defaultContent: "--", searchable: false });
        this.columns.push({
            data: "actions",
            name: "actions",
            title: "Ações",
            orderable: false,
            defaultContent: "--",
            searchable: false
        })
        resolve('');
      }).catch(error => reject(error));
    }));

    promises.push(new Promise((resolve, reject) => {
      let statusService: StatusService = new StatusService();
      statusService.group(5).then((response) => {
        this.product.status = response.find(e => e.name == 'product_ative')
        this.statusList = response;
        resolve(response);
      });
    }));

    promises.push(new Promise((resolve, reject) => {
      let actionService = new ActionService();
      actionService.indexStatus("action_active").then(
        result => {
          this.actionList = result.body;
          resolve(result);
        }
      );
    }));

    this.$.fn.dataTable.ext.buttons.addProduct = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar produto",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-product");
      }
    };

    try {
      await Promise.all(promises);
      this.createDataTable(this);
      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }
}
